// @flow
type Props = $ReadOnly<{
  roi: number,
}>

export default function ProjectRoi({roi}: Props): string {
  return `${I18n.t('projects.my_projects.roi')}  ${roi.toFixed(2)}`
}
